import Axios, {AxiosResponse} from "axios";
import {IProductSearchDto} from "../models/product/product";
import RootApi from "./root-api";

export default class ProductApi extends RootApi {
    private readonly apiEndpoint: string = `${this.ApiRoot}/products`;

    public async searchProducts(request: IProductSearchDto): Promise<AxiosResponse> {
        return await Axios.post(`${this.apiEndpoint}/search`, request);
    }

    public async getProductDetails(id: number): Promise<AxiosResponse> {
        return await Axios.get(`${this.apiEndpoint}/${id}`);
    }
}



// WEBPACK FOOTER //
// ./src/api/product-api.ts